<template>
  <div class="col q-mini-drawer-hide">
    <q-list separator class="tree tree--category tree--full-height">
      <template v-for="cat in categories.data" :key="cat.id">
        <expansion-item
            v-if="expandable"
            expand-icon-toggle
            switch-toggle-side
            :label="cat.title"
            class="tree__item"
            :content-inset-level="0.4"
            default-opened
        >
          <q-list class="tree">
            <template v-for="rule in rules" :key="rule.id">
              <q-item
                  class="tree__item--last"
                  :active="rule.id % 2 === 0"
                  active-class="text-weight-bold text-black-100"
                  @click="openRule"
                  clickable
              >
                <q-item-section side top>
                  <status-dot :status="rule.status" class="q-mt-sm" />
                </q-item-section>
                <q-item-section>
                  <div>{{ rule.code }}</div>
                  <div>{{ rule.title }}</div>
                </q-item-section>
                <q-item-section side top>
                  <icon-button
                      icon="more_horiz"
                      text-color="neutral-40"
                      size="sm"
                      aria-label="Open richtlijn menu"
                      round
                  >
                    <guideline-menu
                        :ref="`menu_${rule.id}`"
                        :item="rule"
                        anchor="bottom left"
                        anchor-self="top left"
                    />
                  </icon-button>
                </q-item-section>
              </q-item>
            </template>
          </q-list>
          <slot name="add-rule" />
        </expansion-item>
        <item-link v-else class="row items-center"
                   :class="{'q-pl-md': $isDesktop}"
                   :href="$route('category.edit', {categorie: cat.id, page: categories.current_page })"
                   :active="cat.id === category?.id">
          {{ cat.title }}
          <q-space />
          <count-chip :count="cat.rule_versions_count" />
        </item-link>
      </template>
      <q-item v-if="categories.last_page > 1" class="flex flex-center">
        <pagination-links :items="categories" />
      </q-item>
    </q-list>
  </div>
</template>

<script>
import GuidelineMenu from '../menu/GuidelineMenu'

export default {
  components: {
    GuidelineMenu,
  },
  props: {
    categories: {
      type: Object,
      default: () => {
        return {}
      },
    },
    rules: {
      type: Array,
      default: () => [],
    },
    expandable: {
      type: Boolean,
      default: false,
    },
    category: {
      type: Object,
      default: null,
    },
  },
}
</script>
